import React from "react";
import { Navbar } from "react-bootstrap";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";

import logoImg from "../../../images/logo/v.png";
import { DarkGrey, White, White08 } from "../../theme/colors";

import { Settings, Notifications } from "@mui/icons-material";
import { StyledLink } from "../../../pages/Home";
import TabSwitcher from "./TabSwitcher";

const NavbarCont = styled(Navbar)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  padding: 100px 30px 30px 30px; /* Gives left/right breathing room */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box; /* Makes sure padding doesn't cause overflow */
  background: ${(props) => props.$background || White};
  z-index: 1000;
`;

const CenterSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const SideSection = styled.div`
  display: flex;
  align-items: center;
  min-width: 85px; /* Ensure equal spacing for logo and settings */
`;

const LogoCont = styled.div`
  background-color: ${DarkGrey};
  height: 40px;
  width: 40px;
  border-radius: 20px;
  padding: 2.5px;
`;

const IconButton = styled.div`
  background-color: ${DarkGrey};
  height: 45px;
  width: 45px;
  border-radius: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

function NavbarComp({ activeTab, onTabChange, showTabs = false, $background }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isOnProfilePage = location.pathname === "/profile";
  const isOnSettingsPage = location.pathname.startsWith("/settings");
  const isOnActivityPage = location.pathname === "/inbox";
  const showSettingsButton = isOnProfilePage || isOnSettingsPage;

  const handleSettingsClick = (e) => {
    e.preventDefault();
    if (isOnSettingsPage) {
      // If on settings page, go back to previous page
      navigate(-1);
    } else {
      // If not on settings page, navigate to settings
      navigate("/settings-overview");
    }
  };

  const handleActivityClick = (e) => {
    e.preventDefault();
    if (isOnActivityPage) {
      // If on activity page, go back to previous page
      navigate(-1);
    } else {
      // If not on activity page, navigate to inbox
      navigate("/inbox");
    }
  };

  return (
    <NavbarCont $background={$background}>
      <SideSection>
        <StyledLink to={`/home`}>
          <LogoCont>
            <img
              src={logoImg}
              alt="Vibe Check Logo"
              style={{ height: "35px" }}
            />
          </LogoCont>
        </StyledLink>
      </SideSection>

      <CenterSection>
        {showTabs && (
          <TabSwitcher activeTab={activeTab} onTabChange={onTabChange} />
        )}
      </CenterSection>

      <SideSection style={{ justifyContent: "flex-end", gap: "5px" }}>
        {!isOnSettingsPage && (
          <div onClick={handleActivityClick}>
            <IconButton>
              <Notifications style={{ fontSize: "25px", color: White08 }} />
            </IconButton>
          </div>
        )}
        {showSettingsButton && (
          <div onClick={handleSettingsClick}>
            <IconButton>
              <Settings style={{ fontSize: "25px", color: White08 }} />
            </IconButton>
          </div>
        )}
      </SideSection>
    </NavbarCont>
  );
}

export default NavbarComp;
